'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeLinkFromFirebase = makeLinkFromFirebase;
exports.makeFirebaseFromLink = makeFirebaseFromLink;
exports.copy = copy;
exports.cut = cut;
exports.paste = paste;

/* injects from baggage-loader */

function makeLinkFromFirebase(info) {
  var link = document.createElement('a');
  link.setAttribute('href', info.href);
  link.innerHTML = info.content;
  if (info.hasOwnProperty('target')) link.setAttribute('target', info.target);
  return link;
}

function makeFirebaseFromLink(link) {
  var info = {};
  info.href = link.hasAttribute('href') ? link.getAttribute('href') : '';
  if (link.hasAttribute('href')) info.target = link.getAttribute('target');
  info.content = link.innerHTML || '';
  return info;
}

function copy(firepad, e) {
  e.preventDefault();
  var selection = firepad.getHtmlFromSelection();

  if (e.clipboardData) {
    e.clipboardData.setData('text/plain', selection.replace(/<(?:.|\n)*?>/gm, '').replace('&nbsp;', ''));
    e.clipboardData.setData('text/html', selection.replace('<div>', '').replace('</div>', ''));
  } else if (window.clipboardData) {
    window.clipboardData.setData('Text', selection.replace('<div>', '').replace('</div>', ''));
  }
}

function cut(firepad, codeMirror, e) {
  copy(firepad, e);
  codeMirror.replaceSelection('');
}

function paste(firepad, e) {
  e.preventDefault();
  var data = e.clipboardData ? e.clipboardData.getData('text/html') : window.clipboardData.getData('Text');
  firepad.insertHtmlAtCursor(data);
}


//////////////////
// WEBPACK FOOTER
// ./app/components/Nodes/editorHelpers.js
// module id = 214
// module chunks = 1